import React from 'react';

import ContentView from '../../components/ui-controls/layout/ContentView';
import FlatListMenu from '../../components/ui-controls/MenuFlatList';
import {AppRoute} from '../../models/AppRoute';
import {InformationContentType, RouteNavigatorScreenProps} from '../../models/navigationTypes';

const InformationScreen = ({navigation}: RouteNavigatorScreenProps<AppRoute.INFORMATION>) => {
  const handleMenuItemPress = ({target}: {target: InformationContentType}) =>
    navigation.navigate(AppRoute.INFORMATION_CONTENT, {
      target,
    });

  const menuItems = [
    {target: InformationContentType.ABOUT_US, name: 'About Us'},
    {
      target: InformationContentType.RETURNS_AND_EXCHANGES,
      name: 'Returns & Exchanges',
    },
    {
      target: InformationContentType.DELIVERY_AND_PICKUP_FAQS,
      name: 'Delivery & Pickup FAQs',
    },
    {
      target: InformationContentType.TERMS_AND_CONDITIONS,
      name: 'Terms & Conditions - Online Ordering',
    },
    {
      target: InformationContentType.REWARDS_PROGRAM_TERMS_AND_CONDITIONS,
      name: 'Terms & Conditions - Loyalty',
    },
    {target: InformationContentType.PRIVACY_POLICY, name: 'Privacy Policy'},
    {
      name: 'Delete Account',
      onPress: () => navigation.navigate(AppRoute.ACCOUNT_DELETE_INFO),
    },
  ];

  return (
    <ContentView testID="information-screen">
      <FlatListMenu data={menuItems} onPressItem={handleMenuItemPress} />
    </ContentView>
  );
};

export default InformationScreen;
